/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaContentObject } from '../../models/criteria-content-object';
import { TextImageContent } from '../../models/text-image-content';

export interface ApiMasterTextImageContentGetByCriteriaPost$Params {
      body?: CriteriaContentObject
}

export function apiMasterTextImageContentGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterTextImageContentGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TextImageContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTextImageContentGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TextImageContent>>;
    })
  );
}

apiMasterTextImageContentGetByCriteriaPost.PATH = '/api/Master/TextImageContent/GetByCriteria';
